<template>
    <div>
            <!-- HEAD -->

            <div class="head row p-0 g-0" data-aos="fade-in" data-aos-delay="100" data-aos-duration="3000" >
                <div class="col-12 col-sm-12 col-md-12 col-lg-7 col-xl-7 col-xxl-7 p-0">
                    <img :src="`${publicPath}img/01crecimiento-head.jpg`" class="img-responsive">
                </div>
                <div class="headRight p-3 pt-xl-2 px-xl-5 px-xxl-0 ps-xxl-5">
                    <div class="row justify-content-end">
                        <div class="col-2 m-0 me-3  mb-4 mt-3 p-0">
                        <img :src="`${publicPath}img/01crecimiento-headIcon.gif`" class="img-responsive">
                    </div>
                    </div>
                    <h2>{{$t('futuro.crecimiento')}}</h2>
                    <p class="text-end pt-2 pt-xl-3">{{ $t('c-intro') }}</p>
                </div>
            </div>

            <!-- end HEAD -->

        <div class="contingut bg-white row g-0">
            <div class="col-10 pt-5 m-auto">
                <h2 class="mb-5" data-aos="fade" data-aos-duration="1500">{{ $t('adquisiciones-para-consolidar-nuevas-categorias-y-regiones') }}</h2>
                <p class="text-turquesa px-1 mx-5" data-aos="fade-left" data-aos-duration="1000" v-html="$t('c-2')"></p>
            </div>
        </div>

        <div class="contingut bg-white row g-0 ">
            <div class="row justify-content-center">
                <div class="col-12 col-lg-10">
                    <div class="row align-items-top">
                        <div class="col-12 col-md-6 col-lg-4 text-start mb-5 mb-lg-0" data-aos="fade-up" data-aos-duration="600">
                            <img :src="`${publicPath}img/01crecimientoRoyo.jpg`" class="img-responsive">
                            <h4 class="text-blau py-3">ROYO</h4>
                            <p>
                                <strong>{{ $t('categoria') }}</strong>: {{ $t('muebles') }}<br>
                                <strong>{{ $t('plantilla') }}</strong>: 795 {{ $t('personas-0') }}<br>
                                <strong>{{ $t('plantas-de-produccion') }}</strong>: {{ $t('3-1-espana-y-2-polonia') }}<br>
                                <strong>{{ $t('capacidad') }}</strong>: {{ $t('1-m-unidades-ano') }}
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 text-start mb-5 mb-lg-0" data-aos="fade-up" data-aos-duration="1000">
                            <img :src="`${publicPath}img/01crecimientoCeara.jpg`" class="img-responsive">
                            <h4 class="text-blau py-3">{{ $t('factoria-en-ceara') }}</h4>
                            <p>
                                <strong>{{ $t('categoria') }}</strong>: {{ $t('porcelana-sanitaria') }}<br>
                                <strong>{{ $t('plantilla') }}</strong>: 227 {{ $t('personas-0') }}<br>
                                <strong>{{ $t('plantas-de-produccion') }}</strong>: 1 ({{ $t('brasil') }})<br>
                                <strong>{{ $t('capacidad') }}</strong>:  {{ $t('1-4-m-piezas-ano') }}
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 text-start" data-aos="fade-up" data-aos-duration="1200">
                            <img :src="`${publicPath}img/01crecimientoSanit.jpg`" class="img-responsive">
                            <h4 class="text-blau py-3">SANIT</h4>
                            <p>
                                <strong>{{ $t('categoria') }}</strong>: {{ $t('cisternas-empotradas-y-sistemas-de-instalacion') }}<br>
                                <strong>{{ $t('plantilla') }}</strong>: 390 {{ $t('personas-0') }}<br>
                                <strong>{{ $t('plantas-de-produccion') }}</strong>: 3 ({{ $t('alemania') }})
                            </p>
                        </div>
                    </div>
                    <hr class="my-5">
                    <div class="row align-items-top g-1 g-lg-0">
                        <div class="col-12 col-md-6 pe-0 pe-lg-5 pb-5 pb-lg-0 text-center text-lg-start" data-aos="fade-right" data-aos-duration="1500">
                            <img :src="`${publicPath}img/01crecimientoConcentracion.jpg`" class="img-responsive">
                            <h3 class="text-blau py-3">{{ $t('concentracion-del-negocio-en-el-espacio-de-bano') }}</h3>
                            <p>{{ $t('c-3') }} </p>
                        </div>
                        <div class="col-12 col-md-6 ps-0 ps-lg-5 text-center text-lg-start" data-aos="fade-left" data-aos-duration="1500">
                            <img :src="`${publicPath}img/01crecimientoAmpliacion.jpg`" class="img-responsive">
                            <h3 class="text-blau py-3">{{ $t('ampliacion-de-la-familia-de-griferia-laufen') }}</h3>
                            <p>{{ $t('c-4') }}</p>
                        </div>
                    </div>
                    <hr class="my-5">
                    <div class="row align-items-top bg-darkBlue ">
                        <div class="col-12 m-0 p-0" data-aos="fade" data-aos-duration="1000">
                                    <img :src="`${publicPath}img/01crecimientoRenovacion.jpg`" class="img-responsive">
                            <div class="row justify-content-center">
                                <div class="col-12 col-lg-11 px-0 py-5 text-center text-lg-start">
                                    <h4 class="text-blau px-3 px-lg-5">{{ $t('renovacion-continua-de-la-tecnologia-de-produccion') }}</h4>
                                    <p class="text-white px-3 px-lg-5 py-3">{{ $t('c-5') }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>


            <div class="contingut bg-white row g-0 mb-5 pb-5">
                <div class="col-12 mt-5 py-5 mb-5 fonsGris position-relative text-center">
                    <h3 class="pb-3 mb-3">{{ $t('contribucion-a-los-ods') }}</h3>
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-2 col-md-auto mb-4 text-center text-lg-start">
                            <p>{{ $t('impacto-directo') }}</p>
                            <img :src="`${publicPath}img/01crecimiento-icono03.gif`" class="img-responsive m-1">
                            <img :src="`${publicPath}img/01crecimiento-icono04.gif`" class="img-responsive m-1">
                        </div>
                        <div class="col-md-auto border-start mb-4 text-center text-lg-start">
                            <p>{{ $t('impacto-indirecto') }}</p>
                            <img :src="`${publicPath}img/01crecimiento-icono01.gif`" class="img-responsive m-1">
                            <img :src="`${publicPath}img/01crecimiento-icono02.gif`" class="img-responsive m-1">
                            <img :src="`${publicPath}img/01crecimiento-icono05.gif`" class="img-responsive m-1">
                            <img :src="`${publicPath}img/01crecimiento-icono06.gif`" class="img-responsive m-1">
                        </div>
                    </div>
                </div>

                <hr>
                <div class="row p-0 g-0">
                    <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-start">
                        <localized-link class="footerLink" to="/avanzando-hacia-el-futuro"><img :src="`${publicPath}img/breadcrumbBack.gif`" class="img-responsive" width="6"> {{ $t("nav.avanzando") }}</localized-link>
                    </div>
                        <div class="col-6 p-3 p-lg-0 m-0 pb-3 text-end">
                        <localized-link class="footerLink" to="/avanzando-hacia-el-futuro/excelencia-operacional">{{ $t("nav.excelencia-operacional") }} <img :src="`${publicPath}img/breadcrumbGo.gif`" class="img-responsive" width="6"></localized-link>
                    </div>
                </div>

            </div>
    </div>
</template>

<script>
  export default {
    name: "AvanzandoHaciaElFuturoCrecimientoView",
    data() {
            return {
                publicPath: process.env.BASE_URL
            }
        }
  }

</script>
